const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://graph.keetqa.com/',
};

export default config;
